module.exports = __webpack_public_path__ + "static/media/new-column-icon.715714a1.svg";